// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/data/v1/data.proto" (package "viam.app.data.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../google/protobuf/field_mask";
import { Struct } from "../../../google/protobuf/struct";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Any } from "../../../google/protobuf/any";
/**
 * DataRequest encapsulates the filter for the data, a limit on the maximum results returned,
 * a last string associated with the last returned document, and the sorting order by time.
 * last is returned in the responses TabularDataByFilterResponse and BinaryDataByFilterResponse
 * from the API calls TabularDataByFilter and BinaryDataByFilter, respectively.
 * We can then use the last string from the previous API calls in the subsequent request
 * to get the next set of ordered documents.
 *
 * @generated from protobuf message viam.app.data.v1.DataRequest
 */
export interface DataRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: uint64 limit = 2;
     */
    limit: string;
    /**
     * @generated from protobuf field: string last = 3;
     */
    last: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.Order sort_order = 4;
     */
    sortOrder: Order;
}
/**
 * Filter defines the fields over which we can filter data using a logic AND.
 * For example, if component_type and robot_id are specified, only data from that `robot_id` of
 * type `component_type` is returned. However, we logical OR over the specified tags and bounding
 * box labels, such that if component_type, robot_id, tagA, tagB are specified,
 * we return data from that `robot_id` of type `component_type` with `tagA` or `tagB`.
 *
 * @generated from protobuf message viam.app.data.v1.Filter
 */
export interface Filter {
    /**
     * @generated from protobuf field: string component_name = 1;
     */
    componentName: string;
    /**
     * @generated from protobuf field: string component_type = 2;
     */
    componentType: string;
    /**
     * @generated from protobuf field: string method = 4;
     */
    method: string;
    /**
     * @generated from protobuf field: string robot_name = 6;
     */
    robotName: string;
    /**
     * @generated from protobuf field: string robot_id = 7;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string part_name = 8;
     */
    partName: string;
    /**
     * @generated from protobuf field: string part_id = 9;
     */
    partId: string;
    /**
     * @generated from protobuf field: repeated string location_ids = 10;
     */
    locationIds: string[];
    /**
     * @generated from protobuf field: repeated string organization_ids = 11;
     */
    organizationIds: string[];
    /**
     * @generated from protobuf field: repeated string mime_type = 12;
     */
    mimeType: string[];
    /**
     * @generated from protobuf field: viam.app.data.v1.CaptureInterval interval = 13;
     */
    interval?: CaptureInterval;
    /**
     * @generated from protobuf field: viam.app.data.v1.TagsFilter tags_filter = 14;
     */
    tagsFilter?: TagsFilter;
    /**
     * bbox_labels are used to match documents with the specified bounding box labels (using logical OR).
     *
     * @generated from protobuf field: repeated string bbox_labels = 15;
     */
    bboxLabels: string[];
    /**
     * @generated from protobuf field: string dataset_id = 16;
     */
    datasetId: string;
}
/**
 * TagsFilter defines the type of filtering and, if applicable, over which tags to perform a logical OR.
 *
 * @generated from protobuf message viam.app.data.v1.TagsFilter
 */
export interface TagsFilter {
    /**
     * @generated from protobuf field: viam.app.data.v1.TagsFilterType type = 1;
     */
    type: TagsFilterType;
    /**
     * Tags are used to match documents if `type` is UNSPECIFIED or MATCH_BY_OR.
     *
     * @generated from protobuf field: repeated string tags = 2;
     */
    tags: string[];
}
/**
 * CaptureMetadata contains information on the settings used for the data capture.
 *
 * @generated from protobuf message viam.app.data.v1.CaptureMetadata
 */
export interface CaptureMetadata {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string location_id = 2;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string robot_name = 3;
     */
    robotName: string;
    /**
     * @generated from protobuf field: string robot_id = 4;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string part_name = 5;
     */
    partName: string;
    /**
     * @generated from protobuf field: string part_id = 6;
     */
    partId: string;
    /**
     * @generated from protobuf field: string component_type = 7;
     */
    componentType: string;
    /**
     * @generated from protobuf field: string component_name = 9;
     */
    componentName: string;
    /**
     * @generated from protobuf field: string method_name = 10;
     */
    methodName: string;
    /**
     * @generated from protobuf field: map<string, google.protobuf.Any> method_parameters = 11;
     */
    methodParameters: {
        [key: string]: Any;
    };
    /**
     * @generated from protobuf field: repeated string tags = 12;
     */
    tags: string[];
    /**
     * @generated from protobuf field: string mime_type = 13;
     */
    mimeType: string;
}
/**
 * CaptureInterval describes the start and end time of the capture in this file.
 *
 * @generated from protobuf message viam.app.data.v1.CaptureInterval
 */
export interface CaptureInterval {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 2;
     */
    end?: Timestamp;
}
/**
 * TabularDataByFilterRequest requests tabular data based on filter values.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.TabularDataByFilterRequest
 */
export interface TabularDataByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.DataRequest data_request = 1;
     */
    dataRequest?: DataRequest;
    /**
     * @generated from protobuf field: bool count_only = 2;
     */
    countOnly: boolean;
    /**
     * @generated from protobuf field: bool include_internal_data = 3;
     */
    includeInternalData: boolean;
}
/**
 * TabularDataByFilterResponse provides the data and metadata of tabular data.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.TabularDataByFilterResponse
 */
export interface TabularDataByFilterResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.CaptureMetadata metadata = 1;
     */
    metadata: CaptureMetadata[];
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.TabularData data = 2;
     */
    data: TabularData[];
    /**
     * @generated from protobuf field: uint64 count = 3;
     */
    count: string;
    /**
     * @generated from protobuf field: string last = 4;
     */
    last: string;
    /**
     * @generated from protobuf field: uint64 total_size_bytes = 5;
     */
    totalSizeBytes: string;
}
/**
 * TabularData contains data and metadata associated with tabular data.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.TabularData
 */
export interface TabularData {
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 1;
     */
    data?: Struct;
    /**
     * @generated from protobuf field: uint32 metadata_index = 2;
     */
    metadataIndex: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_requested = 3;
     */
    timeRequested?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_received = 4;
     */
    timeReceived?: Timestamp;
}
/**
 * TabularDataBySQLRequest requests tabular data using a SQL query.
 *
 * @generated from protobuf message viam.app.data.v1.TabularDataBySQLRequest
 */
export interface TabularDataBySQLRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * sql_query accepts any valid SQL SELECT statement. Tabular data is held in a database
     * called "sensorData" and a table called readings, so queries should select from "readings"
     * or "sensorData.readings".
     *
     * @generated from protobuf field: string sql_query = 2;
     */
    sqlQuery: string;
}
/**
 * TabularDataBySQLResponse provides unified tabular data and metadata, queried with SQL.
 *
 * @generated from protobuf message viam.app.data.v1.TabularDataBySQLResponse
 */
export interface TabularDataBySQLResponse {
    /**
     * @generated from protobuf field: repeated bytes raw_data = 2;
     */
    rawData: Uint8Array[];
}
/**
 * TabularDataSource specifies the data source for user queries to execute on.
 *
 * @generated from protobuf message viam.app.data.v1.TabularDataSource
 */
export interface TabularDataSource {
    /**
     * @generated from protobuf field: viam.app.data.v1.TabularDataSourceType type = 1;
     */
    type: TabularDataSourceType;
    /**
     * pipeline_id is the ID of the pipeline to query. Required when using
     * TABULAR_DATA_SOURCE_TYPE_PIPELINE_SINK.
     *
     * @generated from protobuf field: optional string pipeline_id = 2;
     */
    pipelineId?: string;
}
/**
 * TabularDataByMQLRequest requests tabular data using an MQL query.
 *
 * @generated from protobuf message viam.app.data.v1.TabularDataByMQLRequest
 */
export interface TabularDataByMQLRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * mql_binary accepts a MongoDB aggregation pipeline as a list of BSON documents, where each
     * document is one stage in the pipeline. The pipeline is run on the "sensorData.readings"
     * namespace, which holds the Viam organization's tabular data.
     *
     * @generated from protobuf field: repeated bytes mql_binary = 3;
     */
    mqlBinary: Uint8Array[];
    /**
     * Deprecated, please use TABULAR_DATA_SOURCE_TYPE_HOT_STORAGE instead.
     *
     * @generated from protobuf field: optional bool use_recent_data = 4;
     */
    useRecentData?: boolean;
    /**
     * data_source is an optional field that can be used to specify the data source for the query.
     * If not specified, the query will run on "standard" storage.
     *
     * @generated from protobuf field: optional viam.app.data.v1.TabularDataSource data_source = 6;
     */
    dataSource?: TabularDataSource;
    /**
     * query_prefix_name is an optional field that can be used to specify a saved query to run
     *
     * @generated from protobuf field: optional string query_prefix_name = 7;
     */
    queryPrefixName?: string;
}
/**
 * TabularDataByMQLResponse provides unified tabular data and metadata, queried with MQL.
 *
 * @generated from protobuf message viam.app.data.v1.TabularDataByMQLResponse
 */
export interface TabularDataByMQLResponse {
    /**
     * @generated from protobuf field: repeated bytes raw_data = 2;
     */
    rawData: Uint8Array[];
}
/**
 * ExportTabularDataRequest requests tabular data from the specified data source.
 *
 * @generated from protobuf message viam.app.data.v1.ExportTabularDataRequest
 */
export interface ExportTabularDataRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string resource_subtype = 3;
     */
    resourceSubtype: string;
    /**
     * @generated from protobuf field: string method_name = 4;
     */
    methodName: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.CaptureInterval interval = 5;
     */
    interval?: CaptureInterval;
    /**
     * @generated from protobuf field: optional google.protobuf.Struct additional_parameters = 6;
     */
    additionalParameters?: Struct;
}
/**
 * ExportTabularDataResponse provides unified tabular data and metadata for a single data point from the specified data source.
 *
 * @generated from protobuf message viam.app.data.v1.ExportTabularDataResponse
 */
export interface ExportTabularDataResponse {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string resource_subtype = 3;
     */
    resourceSubtype: string;
    /**
     * @generated from protobuf field: string method_name = 4;
     */
    methodName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_captured = 5;
     */
    timeCaptured?: Timestamp;
    /**
     * @generated from protobuf field: string organization_id = 6;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string location_id = 7;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string robot_name = 8;
     */
    robotName: string;
    /**
     * @generated from protobuf field: string robot_id = 9;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string part_name = 10;
     */
    partName: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct method_parameters = 11;
     */
    methodParameters?: Struct;
    /**
     * @generated from protobuf field: repeated string tags = 12;
     */
    tags: string[];
    /**
     * @generated from protobuf field: google.protobuf.Struct payload = 13;
     */
    payload?: Struct;
}
/**
 * GetLatestTabularDataRequest requests the most recent tabular data captured from the specified data source.
 *
 * @generated from protobuf message viam.app.data.v1.GetLatestTabularDataRequest
 */
export interface GetLatestTabularDataRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string method_name = 3;
     */
    methodName: string;
    /**
     * @generated from protobuf field: string resource_subtype = 4;
     */
    resourceSubtype: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Struct additional_parameters = 5;
     */
    additionalParameters?: Struct;
}
/**
 * GetLatestTabularDataResponse provides the data, time synced, and time captured of the most recent tabular data captured
 * from the requested data source, as long as it was synced within the last year.
 *
 * @generated from protobuf message viam.app.data.v1.GetLatestTabularDataResponse
 */
export interface GetLatestTabularDataResponse {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_captured = 1;
     */
    timeCaptured?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_synced = 2;
     */
    timeSynced?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct payload = 3;
     */
    payload?: Struct;
}
/**
 * BinaryData contains data and metadata associated with binary data.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryData
 */
export interface BinaryData {
    /**
     * @generated from protobuf field: bytes binary = 1;
     */
    binary: Uint8Array;
    /**
     * @generated from protobuf field: viam.app.data.v1.BinaryMetadata metadata = 2;
     */
    metadata?: BinaryMetadata;
}
/**
 * BinaryDataByFilterRequest requests the data and metadata of binary (image + file) data when a filter is provided.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryDataByFilterRequest
 */
export interface BinaryDataByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.DataRequest data_request = 1;
     */
    dataRequest?: DataRequest;
    /**
     * @generated from protobuf field: bool include_binary = 2;
     */
    includeBinary: boolean;
    /**
     * @generated from protobuf field: bool count_only = 3;
     */
    countOnly: boolean;
    /**
     * @generated from protobuf field: bool include_internal_data = 4;
     */
    includeInternalData: boolean;
}
/**
 * BinaryDataByFilterResponse provides the data and metadata of binary (image + file) data when a filter is provided.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryDataByFilterResponse
 */
export interface BinaryDataByFilterResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryData data = 1;
     */
    data: BinaryData[];
    /**
     * @generated from protobuf field: uint64 count = 2;
     */
    count: string;
    /**
     * @generated from protobuf field: string last = 3;
     */
    last: string;
    /**
     * @generated from protobuf field: uint64 total_size_bytes = 4;
     */
    totalSizeBytes: string;
}
/**
 * BinaryID is the unique identifier for a file that one can request to be retrieved or modified.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.BinaryID
 */
export interface BinaryID {
    /**
     * @generated from protobuf field: string file_id = 1;
     */
    fileId: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string location_id = 3;
     */
    locationId: string;
}
/**
 * BinaryDataByFilterRequest requests the data and metadata of binary (image + file) data by binary ids.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryDataByIDsRequest
 */
export interface BinaryDataByIDsRequest {
    /**
     * @generated from protobuf field: bool include_binary = 2;
     */
    includeBinary: boolean;
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 3 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 4;
     */
    binaryDataIds: string[];
}
/**
 * BinaryDataByIDsResponse provides the data and metadata of binary (image + file) data when a filter is provided.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryDataByIDsResponse
 */
export interface BinaryDataByIDsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryData data = 1;
     */
    data: BinaryData[];
    /**
     * @generated from protobuf field: uint64 count = 2;
     */
    count: string;
}
/**
 * BoundingBox represents a labeled bounding box on an image.
 * x and y values are normalized ratios between 0 and 1.
 *
 * @generated from protobuf message viam.app.data.v1.BoundingBox
 */
export interface BoundingBox {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string label = 2;
     */
    label: string;
    /**
     * @generated from protobuf field: double x_min_normalized = 3;
     */
    xMinNormalized: number;
    /**
     * @generated from protobuf field: double y_min_normalized = 4;
     */
    yMinNormalized: number;
    /**
     * @generated from protobuf field: double x_max_normalized = 5;
     */
    xMaxNormalized: number;
    /**
     * @generated from protobuf field: double y_max_normalized = 6;
     */
    yMaxNormalized: number;
    /**
     * confidence is an optional range from 0 - 1
     *
     * @generated from protobuf field: optional double confidence = 7;
     */
    confidence?: number;
}
/**
 * Classification represents a confidence score with a label.
 *
 * @generated from protobuf message viam.app.data.v1.Classification
 */
export interface Classification {
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: string label = 1;
     */
    label: string;
    /**
     * confidence is an optional range from 0 - 1
     *
     * @generated from protobuf field: optional double confidence = 2;
     */
    confidence?: number;
}
/**
 * Annotations are data annotations used for machine learning.
 *
 * @generated from protobuf message viam.app.data.v1.Annotations
 */
export interface Annotations {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.BoundingBox bboxes = 1;
     */
    bboxes: BoundingBox[];
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Classification classifications = 2;
     */
    classifications: Classification[];
}
/**
 * BinaryMetadata is the metadata associated with binary data.
 *
 * @generated from protobuf message viam.app.data.v1.BinaryMetadata
 */
export interface BinaryMetadata {
    /**
     * @deprecated
     * @generated from protobuf field: string id = 1 [deprecated = true];
     */
    id: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.CaptureMetadata capture_metadata = 2;
     */
    captureMetadata?: CaptureMetadata;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_requested = 3;
     */
    timeRequested?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_received = 4;
     */
    timeReceived?: Timestamp;
    /**
     * @generated from protobuf field: string file_name = 5;
     */
    fileName: string;
    /**
     * @generated from protobuf field: string file_ext = 6;
     */
    fileExt: string;
    /**
     * @generated from protobuf field: string uri = 7;
     */
    uri: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations annotations = 8;
     */
    annotations?: Annotations;
    /**
     * @generated from protobuf field: repeated string dataset_ids = 9;
     */
    datasetIds: string[];
    /**
     * @generated from protobuf field: string binary_data_id = 10;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: uint64 file_size_bytes = 11;
     */
    fileSizeBytes: string;
}
/**
 * TabularFilter filters tabular data. All fields are optional; omitted fields are treated as unconstrained.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteTabularFilter
 */
export interface DeleteTabularFilter {
    /**
     * @generated from protobuf field: repeated string location_ids = 1;
     */
    locationIds: string[];
    /**
     * @generated from protobuf field: string robot_id = 2;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string part_id = 3;
     */
    partId: string;
    /**
     * @generated from protobuf field: string component_type = 4;
     */
    componentType: string;
    /**
     * @generated from protobuf field: string component_name = 5;
     */
    componentName: string;
    /**
     * @generated from protobuf field: string method = 6;
     */
    method: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.TagsFilter tags_filter = 7;
     */
    tagsFilter?: TagsFilter;
}
/**
 * DeleteTabularDataRequest deletes the data from the organization that is older than `delete_older_than_days`
 * in UTC time. For example, if delete_older_than_days=1 and the request is made at 1AM EST on March 11
 * (March 11 5AM UTC), this deletes all data captured through March 10 11:59:59PM UTC.
 * If the request is at 10PM EST on March 11 (March 12 2AM UTC), this deletes all data captured
 * through March 11 11:59:59PM UTC.
 * If delete_older_than_days is 0, all existing data is deleted.
 * If no filter is provided, data will be deleted based on organization_id.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteTabularDataRequest
 */
export interface DeleteTabularDataRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: uint32 delete_older_than_days = 2;
     */
    deleteOlderThanDays: number;
    /**
     * @generated from protobuf field: optional viam.app.data.v1.DeleteTabularFilter filter = 3;
     */
    filter?: DeleteTabularFilter;
}
/**
 * DeleteBinaryDataResponse returns the number of tabular datapoints deleted.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteTabularDataResponse
 */
export interface DeleteTabularDataResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * DeleteBinaryDataByFilterRequest deletes the data and metadata of binary data when a filter is provided.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteBinaryDataByFilterRequest
 */
export interface DeleteBinaryDataByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: bool include_internal_data = 2;
     */
    includeInternalData: boolean;
}
/**
 * DeleteBinaryDataByFilterResponse returns the number of binary files deleted when a filter is provided.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteBinaryDataByFilterResponse
 */
export interface DeleteBinaryDataByFilterResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * DeleteBinaryDataByIDsRequest deletes the data and metadata of binary data when binary ids are provided.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteBinaryDataByIDsRequest
 */
export interface DeleteBinaryDataByIDsRequest {
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 2 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 3;
     */
    binaryDataIds: string[];
}
/**
 * DeleteBinaryDataByIDsResponse returns the number of binary files deleted when binary ids are provided.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteBinaryDataByIDsResponse
 */
export interface DeleteBinaryDataByIDsResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * AddTagsToBinaryDataByIDsRequest requests adding all specified tags to each of the files when binary ids are provided.
 *
 * @generated from protobuf message viam.app.data.v1.AddTagsToBinaryDataByIDsRequest
 */
export interface AddTagsToBinaryDataByIDsRequest {
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 3 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 4;
     */
    binaryDataIds: string[];
    /**
     * @generated from protobuf field: repeated string tags = 2;
     */
    tags: string[];
}
/**
 * @generated from protobuf message viam.app.data.v1.AddTagsToBinaryDataByIDsResponse
 */
export interface AddTagsToBinaryDataByIDsResponse {
}
/**
 * AddTagsToBinaryDataByFilterRequest requests adding all specified tags to each of the files when a filter is provided.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.AddTagsToBinaryDataByFilterRequest
 */
export interface AddTagsToBinaryDataByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: repeated string tags = 2;
     */
    tags: string[];
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.AddTagsToBinaryDataByFilterResponse
 */
export interface AddTagsToBinaryDataByFilterResponse {
}
/**
 * RemoveTagsFromBinaryDataByIDsRequest requests removing the given tags value from each file when binary ids are provided.
 *
 * @generated from protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest
 */
export interface RemoveTagsFromBinaryDataByIDsRequest {
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 3 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 4;
     */
    binaryDataIds: string[];
    /**
     * @generated from protobuf field: repeated string tags = 2;
     */
    tags: string[];
}
/**
 * RemoveTagsFromBinaryDataByIDsResponse returns the number of binary files which had tags removed
 *
 * @generated from protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse
 */
export interface RemoveTagsFromBinaryDataByIDsResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * RemoveTagsFromBinaryDataByFilterRequest requests removing the given tags value from each file when a filter is provided.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest
 */
export interface RemoveTagsFromBinaryDataByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: repeated string tags = 2;
     */
    tags: string[];
}
/**
 * RemoveTagsFromBinaryDataByFilterResponse returns the number of binary files which had tags removed.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse
 */
export interface RemoveTagsFromBinaryDataByFilterResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * TagsByFilterRequest requests the unique tags from data based on given filter.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.TagsByFilterRequest
 */
export interface TagsByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
}
/**
 * TagsByFilterResponse returns the unique tags from data based on given filter.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.TagsByFilterResponse
 */
export interface TagsByFilterResponse {
    /**
     * @generated from protobuf field: repeated string tags = 1;
     */
    tags: string[];
}
/**
 * AddBoundingBoxToImageByIDRequest specifies the binary ID to which a bounding box
 * with the associated label and position in normalized coordinates will be added.
 *
 * @generated from protobuf message viam.app.data.v1.AddBoundingBoxToImageByIDRequest
 */
export interface AddBoundingBoxToImageByIDRequest {
    /**
     * @deprecated
     * @generated from protobuf field: viam.app.data.v1.BinaryID binary_id = 7 [deprecated = true];
     */
    binaryId?: BinaryID;
    /**
     * @generated from protobuf field: string binary_data_id = 8;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string label = 2;
     */
    label: string;
    /**
     * @generated from protobuf field: double x_min_normalized = 3;
     */
    xMinNormalized: number;
    /**
     * @generated from protobuf field: double y_min_normalized = 4;
     */
    yMinNormalized: number;
    /**
     * @generated from protobuf field: double x_max_normalized = 5;
     */
    xMaxNormalized: number;
    /**
     * @generated from protobuf field: double y_max_normalized = 6;
     */
    yMaxNormalized: number;
    /**
     * @generated from protobuf field: optional double confidence = 9;
     */
    confidence?: number;
}
/**
 * AddBoundingBoxToImageByIDResponse returns the bounding box ID of the successfully added bounding box.
 *
 * @generated from protobuf message viam.app.data.v1.AddBoundingBoxToImageByIDResponse
 */
export interface AddBoundingBoxToImageByIDResponse {
    /**
     * @generated from protobuf field: string bbox_id = 1;
     */
    bboxId: string;
}
/**
 * RemoveBoundingBoxFromImageByIDRequest removes the bounding box with specified bounding box ID for the file represented by the binary ID.
 *
 * @generated from protobuf message viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest
 */
export interface RemoveBoundingBoxFromImageByIDRequest {
    /**
     * @deprecated
     * @generated from protobuf field: viam.app.data.v1.BinaryID binary_id = 3 [deprecated = true];
     */
    binaryId?: BinaryID;
    /**
     * @generated from protobuf field: string binary_data_id = 4;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string bbox_id = 2;
     */
    bboxId: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse
 */
export interface RemoveBoundingBoxFromImageByIDResponse {
}
/**
 * UpdateBoundingBoxRequest updates the bounding box with specified bounding box ID for the file represented by the binary ID.
 *
 * @generated from protobuf message viam.app.data.v1.UpdateBoundingBoxRequest
 */
export interface UpdateBoundingBoxRequest {
    /**
     * @deprecated
     * @generated from protobuf field: viam.app.data.v1.BinaryID binary_id = 1 [deprecated = true];
     */
    binaryId?: BinaryID;
    /**
     * @generated from protobuf field: string binary_data_id = 8;
     */
    binaryDataId: string;
    /**
     * @generated from protobuf field: string bbox_id = 2;
     */
    bboxId: string;
    /**
     * @generated from protobuf field: optional string label = 3;
     */
    label?: string;
    /**
     * @generated from protobuf field: optional double x_min_normalized = 4;
     */
    xMinNormalized?: number;
    /**
     * @generated from protobuf field: optional double y_min_normalized = 5;
     */
    yMinNormalized?: number;
    /**
     * @generated from protobuf field: optional double x_max_normalized = 6;
     */
    xMaxNormalized?: number;
    /**
     * @generated from protobuf field: optional double y_max_normalized = 7;
     */
    yMaxNormalized?: number;
    /**
     * @generated from protobuf field: optional double confidence = 9;
     */
    confidence?: number;
}
/**
 * @generated from protobuf message viam.app.data.v1.UpdateBoundingBoxResponse
 */
export interface UpdateBoundingBoxResponse {
}
/**
 * BoundingBoxLabelsByFilterRequest requests all the labels of the bounding boxes from files from a given filter.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.BoundingBoxLabelsByFilterRequest
 */
export interface BoundingBoxLabelsByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
}
/**
 * BoundingBoxLabelsByFilterRequest returns all the labels of the bounding boxes from files from a given filter.
 *
 * @deprecated
 * @generated from protobuf message viam.app.data.v1.BoundingBoxLabelsByFilterResponse
 */
export interface BoundingBoxLabelsByFilterResponse {
    /**
     * @generated from protobuf field: repeated string labels = 1;
     */
    labels: string[];
}
/**
 * ConfigureDatabaseUserRequest accepts a Viam organization ID and a password for the database user
 * being configured. Viam uses gRPC over TLS, so the entire request will be encrypted while in
 * flight, including the password.
 *
 * @generated from protobuf message viam.app.data.v1.ConfigureDatabaseUserRequest
 */
export interface ConfigureDatabaseUserRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string password = 2;
     */
    password: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.ConfigureDatabaseUserResponse
 */
export interface ConfigureDatabaseUserResponse {
}
/**
 * GetDatabaseConnectionRequest requests the database connection hostname.
 *
 * @generated from protobuf message viam.app.data.v1.GetDatabaseConnectionRequest
 */
export interface GetDatabaseConnectionRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * GetDatabaseConnectionResponse returns the database connection hostname endpoint. It also returns
 * a URI that can be used to connect to the database instance through MongoDB clients, as well as
 * information on whether the Viam organization has a database user configured.
 *
 * @generated from protobuf message viam.app.data.v1.GetDatabaseConnectionResponse
 */
export interface GetDatabaseConnectionResponse {
    /**
     * @generated from protobuf field: string hostname = 1;
     */
    hostname: string;
    /**
     * @generated from protobuf field: string mongodb_uri = 2;
     */
    mongodbUri: string;
    /**
     * @generated from protobuf field: bool has_database_user = 3;
     */
    hasDatabaseUser: boolean;
}
/**
 * AddBinaryDataToDatasetByIDsRequest adds the binary data with the given binary IDs to a dataset with dataset_id.
 *
 * @generated from protobuf message viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest
 */
export interface AddBinaryDataToDatasetByIDsRequest {
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 1 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 3;
     */
    binaryDataIds: string[];
    /**
     * @generated from protobuf field: string dataset_id = 2;
     */
    datasetId: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse
 */
export interface AddBinaryDataToDatasetByIDsResponse {
}
/**
 * RemoveBinaryDataFromDatasetByIDsRequest removes the specified binary IDs from a dataset with dataset_id.
 *
 * @generated from protobuf message viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest
 */
export interface RemoveBinaryDataFromDatasetByIDsRequest {
    /**
     * @deprecated
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryID binary_ids = 1 [deprecated = true];
     */
    binaryIds: BinaryID[];
    /**
     * @generated from protobuf field: repeated string binary_data_ids = 3;
     */
    binaryDataIds: string[];
    /**
     * @generated from protobuf field: string dataset_id = 2;
     */
    datasetId: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse
 */
export interface RemoveBinaryDataFromDatasetByIDsResponse {
}
/**
 * AddSequencesToDatasetRequest adds the sequences with the given IDs to the dataset with dataset_id.
 *
 * @generated from protobuf message viam.app.data.v1.AddSequencesToDatasetRequest
 */
export interface AddSequencesToDatasetRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: repeated string sequence_ids = 2;
     */
    sequenceIds: string[];
}
/**
 * @generated from protobuf message viam.app.data.v1.AddSequencesToDatasetResponse
 */
export interface AddSequencesToDatasetResponse {
}
/**
 * RemoveSequencesFromDatasetRequest removes the sequences with the given IDs from the dataset with dataset_id.
 *
 * @generated from protobuf message viam.app.data.v1.RemoveSequencesFromDatasetRequest
 */
export interface RemoveSequencesFromDatasetRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: repeated string sequence_ids = 2;
     */
    sequenceIds: string[];
}
/**
 * @generated from protobuf message viam.app.data.v1.RemoveSequencesFromDatasetResponse
 */
export interface RemoveSequencesFromDatasetResponse {
}
/**
 * CreateIndexRequest starts a custom index build
 *
 * @generated from protobuf message viam.app.data.v1.CreateIndexRequest
 */
export interface CreateIndexRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 2;
     */
    collectionType: IndexableCollection;
    /**
     * @generated from protobuf field: optional string pipeline_name = 3;
     */
    pipelineName?: string;
    /**
     * index_spec accepts a MongoDB index specification defined in JSON format
     *
     * @generated from protobuf field: repeated bytes index_spec = 4;
     */
    indexSpec: Uint8Array[];
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateIndexResponse
 */
export interface CreateIndexResponse {
}
/**
 * DeleteIndexRequest drops the specified custom index from a collection
 *
 * @generated from protobuf message viam.app.data.v1.DeleteIndexRequest
 */
export interface DeleteIndexRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 2;
     */
    collectionType: IndexableCollection;
    /**
     * @generated from protobuf field: optional string pipeline_name = 3;
     */
    pipelineName?: string;
    /**
     * @generated from protobuf field: string index_name = 4;
     */
    indexName: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.DeleteIndexResponse
 */
export interface DeleteIndexResponse {
}
/**
 * ListIndexesRequest returns all the indexes for a given collection
 *
 * @generated from protobuf message viam.app.data.v1.ListIndexesRequest
 */
export interface ListIndexesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 2;
     */
    collectionType: IndexableCollection;
    /**
     * @generated from protobuf field: optional string pipeline_name = 3;
     */
    pipelineName?: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.ListIndexesResponse
 */
export interface ListIndexesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Index indexes = 1;
     */
    indexes: Index[];
}
/**
 * @generated from protobuf message viam.app.data.v1.Index
 */
export interface Index {
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 1;
     */
    collectionType: IndexableCollection;
    /**
     * @generated from protobuf field: optional string pipeline_name = 2;
     */
    pipelineName?: string;
    /**
     * @generated from protobuf field: string index_name = 3;
     */
    indexName: string;
    /**
     * index_spec defines a MongoDB index in JSON format
     *
     * @generated from protobuf field: repeated bytes index_spec = 4;
     */
    indexSpec: Uint8Array[];
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexCreator created_by = 5;
     */
    createdBy: IndexCreator;
}
/**
 * CreateSavedQueryRequest saves a mql query.
 *
 * @generated from protobuf message viam.app.data.v1.CreateSavedQueryRequest
 */
export interface CreateSavedQueryRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated bytes mql_binary = 3;
     */
    mqlBinary: Uint8Array[];
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateSavedQueryResponse
 */
export interface CreateSavedQueryResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.Query
 */
export interface Query {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated bytes mql_binary = 4;
     */
    mqlBinary: Uint8Array[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 5;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
}
/**
 * DeleteSavedQuery deletes a saved query based on the given id.
 *
 * @generated from protobuf message viam.app.data.v1.DeleteSavedQueryRequest
 */
export interface DeleteSavedQueryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.DeleteSavedQueryResponse
 */
export interface DeleteSavedQueryResponse {
}
/**
 * GetSavedQuery retrieves a saved query by id.
 *
 * @generated from protobuf message viam.app.data.v1.GetSavedQueryRequest
 */
export interface GetSavedQueryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.GetSavedQueryResponse
 */
export interface GetSavedQueryResponse {
    /**
     * @generated from protobuf field: viam.app.data.v1.Query saved_query = 1;
     */
    savedQuery?: Query;
}
/**
 * UpdateSavedQuery updates the saved query with the given id.
 *
 * @generated from protobuf message viam.app.data.v1.UpdateSavedQueryRequest
 */
export interface UpdateSavedQueryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated bytes mql_binary = 3;
     */
    mqlBinary: Uint8Array[];
}
/**
 * @generated from protobuf message viam.app.data.v1.UpdateSavedQueryResponse
 */
export interface UpdateSavedQueryResponse {
}
/**
 * ListSavedQueries lists saved queries for a given organization.
 *
 * @generated from protobuf message viam.app.data.v1.ListSavedQueriesRequest
 */
export interface ListSavedQueriesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 limit = 2;
     */
    limit: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.ListSavedQueriesResponse
 */
export interface ListSavedQueriesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Query queries = 1;
     */
    queries: Query[];
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateBinaryDataSignedURLRequest
 */
export interface CreateBinaryDataSignedURLRequest {
    /**
     * The binary data ID of the file to create a signed URL for.
     *
     * @generated from protobuf field: string binary_data_id = 1;
     */
    binaryDataId: string;
    /**
     * Expiration time in minutes. Defaults to 15 minutes if not specified.
     * Maximum allowed is 10080 minutes (7 days).
     *
     * @generated from protobuf field: optional uint32 expiration_minutes = 2;
     */
    expirationMinutes?: number;
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateBinaryDataSignedURLResponse
 */
export interface CreateBinaryDataSignedURLResponse {
    /**
     * The signed URL for the binary data file.
     *
     * @generated from protobuf field: string signed_url = 1;
     */
    signedUrl: string;
    /**
     * Expiration time of the signed URL token.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 2;
     */
    expiresAt?: Timestamp;
}
/**
 * SequenceResourceFilter filters binary and/or tabular data by source identifiers.
 *
 * @generated from protobuf message viam.app.data.v1.SequenceResourceFilter
 */
export interface SequenceResourceFilter {
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string method_name = 3;
     */
    methodName: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.Sequence
 */
export interface Sequence {
    /**
     * Metadata associated with the sequence.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string part_id = 9;
     */
    partId: string;
    /**
     * @generated from protobuf field: repeated string sequence_tags = 3;
     */
    sequenceTags: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The time range the sequence applies to.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;
    /**
     * Resources whose data is associated with this sequence.
     *
     * @generated from protobuf field: repeated viam.app.data.v1.SequenceResourceFilter resources = 8;
     */
    resources: SequenceResourceFilter[];
    /**
     * Datasets this sequence is a member of. Membership is added/removed via
     * AddSequencesToDataset / RemoveSequencesFromDataset.
     *
     * @generated from protobuf field: repeated string dataset_ids = 10;
     */
    datasetIds: string[];
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateSequenceRequest
 */
export interface CreateSequenceRequest {
    /**
     * @generated from protobuf field: string part_id = 6;
     */
    partId: string;
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.SequenceResourceFilter resources = 2;
     */
    resources: SequenceResourceFilter[];
    /**
     * @generated from protobuf field: repeated string sequence_tags = 3;
     */
    sequenceTags: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 4;
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 5;
     */
    endTime?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.data.v1.CreateSequenceResponse
 */
export interface CreateSequenceResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.GetSequenceRequest
 */
export interface GetSequenceRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.GetSequenceResponse
 */
export interface GetSequenceResponse {
    /**
     * @generated from protobuf field: viam.app.data.v1.Sequence sequence = 1;
     */
    sequence?: Sequence;
}
/**
 * UpdateSequenceRequest updates the mutable fields of a sequence.
 * Only fields listed in field_mask will be updated; others are left unchanged.
 * Fields 2-5 are allowed fields for the field_mask.
 *
 * @generated from protobuf message viam.app.data.v1.UpdateSequenceRequest
 */
export interface UpdateSequenceRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.SequenceResourceFilter resources = 2;
     */
    resources: SequenceResourceFilter[];
    /**
     * @generated from protobuf field: repeated string sequence_tags = 3;
     */
    sequenceTags: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 4;
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 5;
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask field_mask = 6;
     */
    fieldMask?: FieldMask;
}
/**
 * @generated from protobuf message viam.app.data.v1.UpdateSequenceResponse
 */
export interface UpdateSequenceResponse {
}
/**
 * @generated from protobuf message viam.app.data.v1.DeleteSequenceRequest
 */
export interface DeleteSequenceRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.DeleteSequenceResponse
 */
export interface DeleteSequenceResponse {
}
/**
 * @generated from protobuf message viam.app.data.v1.ListSequencesRequest
 */
export interface ListSequencesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: uint32 page_size = 3;
     */
    pageSize: number;
}
/**
 * @generated from protobuf message viam.app.data.v1.ListSequencesResponse
 */
export interface ListSequencesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Sequence sequences = 1;
     */
    sequences: Sequence[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.SequencesByDatasetIDRequest
 */
export interface SequencesByDatasetIDRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: uint32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: bool count_only = 4;
     */
    countOnly: boolean;
}
/**
 * @generated from protobuf message viam.app.data.v1.SequencesByDatasetIDResponse
 */
export interface SequencesByDatasetIDResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Sequence sequences = 1;
     */
    sequences: Sequence[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: uint64 count = 3;
     */
    count: string;
}
/**
 * @generated from protobuf message viam.app.data.v1.GetSequenceBinaryDataRequest
 */
export interface GetSequenceBinaryDataRequest {
    /**
     * @generated from protobuf field: string sequence_id = 1;
     */
    sequenceId: string;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: uint32 page_size = 3;
     */
    pageSize: number;
}
/**
 * @generated from protobuf message viam.app.data.v1.GetSequenceBinaryDataResponse
 */
export interface GetSequenceBinaryDataResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryData data = 1;
     */
    data: BinaryData[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Order specifies the order in which data is returned.
 *
 * @generated from protobuf enum viam.app.data.v1.Order
 */
export enum Order {
    /**
     * @generated from protobuf enum value: ORDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ORDER_DESCENDING = 1;
     */
    DESCENDING = 1,
    /**
     * @generated from protobuf enum value: ORDER_ASCENDING = 2;
     */
    ASCENDING = 2
}
/**
 * TagsFilterType specifies how data can be filtered based on tags.
 *
 * @generated from protobuf enum viam.app.data.v1.TagsFilterType
 */
export enum TagsFilterType {
    /**
     * @generated from protobuf enum value: TAGS_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TAGS_FILTER_TYPE_MATCH_BY_OR specifies documents matched (using logical OR) on the tags field in the TagsFilter.
     *
     * @generated from protobuf enum value: TAGS_FILTER_TYPE_MATCH_BY_OR = 1;
     */
    MATCH_BY_OR = 1,
    /**
     * TAGS_FILTER_TYPE_TAGGED specifies that all tagged documents should be returned.
     *
     * @generated from protobuf enum value: TAGS_FILTER_TYPE_TAGGED = 2;
     */
    TAGGED = 2,
    /**
     * TAGS_FILTER_TYPE_UNTAGGED specifes that all untagged documents should be returned.
     *
     * @generated from protobuf enum value: TAGS_FILTER_TYPE_UNTAGGED = 3;
     */
    UNTAGGED = 3
}
/**
 * TabularDataSourceType specifies the data source type for TabularDataByMQL queries.
 *
 * @generated from protobuf enum viam.app.data.v1.TabularDataSourceType
 */
export enum TabularDataSourceType {
    /**
     * @generated from protobuf enum value: TABULAR_DATA_SOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TABULAR_DATA_SOURCE_TYPE_STANDARD indicates reading from standard storage. This is
     * the default option and available for all data synced to Viam.
     *
     * @generated from protobuf enum value: TABULAR_DATA_SOURCE_TYPE_STANDARD = 1;
     */
    STANDARD = 1,
    /**
     * TABULAR_DATA_SOURCE_TYPE_HOT_STORAGE indicates reading from hot storage. This is a
     * premium feature requiring opting in specific data sources.
     * See docs at https://docs.viam.com/data-ai/capture-data/advanced/advanced-data-capture-sync/#capture-to-the-hot-data-store
     *
     * @generated from protobuf enum value: TABULAR_DATA_SOURCE_TYPE_HOT_STORAGE = 2;
     */
    HOT_STORAGE = 2,
    /**
     * TABULAR_DATA_SOURCE_TYPE_PIPELINE_SINK indicates reading the output data of
     * a data pipeline. When using this, a pipeline ID needs to be specified.
     *
     * @generated from protobuf enum value: TABULAR_DATA_SOURCE_TYPE_PIPELINE_SINK = 3;
     */
    PIPELINE_SINK = 3
}
/**
 * IndexableCollection specifies the types of collections available for custom indexes
 *
 * @generated from protobuf enum viam.app.data.v1.IndexableCollection
 */
export enum IndexableCollection {
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_HOT_STORE = 1;
     */
    HOT_STORE = 1,
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_PIPELINE_SINK = 2;
     */
    PIPELINE_SINK = 2
}
/**
 * IndexCreator specifies the entity that originally created the index
 *
 * @generated from protobuf enum viam.app.data.v1.IndexCreator
 */
export enum IndexCreator {
    /**
     * @generated from protobuf enum value: INDEX_CREATOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INDEX_CREATOR_VIAM = 1;
     */
    VIAM = 1,
    /**
     * @generated from protobuf enum value: INDEX_CREATOR_CUSTOMER = 2;
     */
    CUSTOMER = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class DataRequest$Type extends MessageType<DataRequest> {
    constructor() {
        super("viam.app.data.v1.DataRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sort_order", kind: "enum", T: () => ["viam.app.data.v1.Order", Order, "ORDER_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DataRequest
 */
export const DataRequest = new DataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Filter$Type extends MessageType<Filter> {
    constructor() {
        super("viam.app.data.v1.Filter", [
            { no: 1, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "component_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "robot_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "location_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "organization_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "mime_type", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "interval", kind: "message", T: () => CaptureInterval },
            { no: 14, name: "tags_filter", kind: "message", T: () => TagsFilter },
            { no: 15, name: "bbox_labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Filter
 */
export const Filter = new Filter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TagsFilter$Type extends MessageType<TagsFilter> {
    constructor() {
        super("viam.app.data.v1.TagsFilter", [
            { no: 1, name: "type", kind: "enum", T: () => ["viam.app.data.v1.TagsFilterType", TagsFilterType, "TAGS_FILTER_TYPE_"] },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TagsFilter
 */
export const TagsFilter = new TagsFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CaptureMetadata$Type extends MessageType<CaptureMetadata> {
    constructor() {
        super("viam.app.data.v1.CaptureMetadata", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "robot_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "component_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "method_parameters", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Any } },
            { no: 12, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CaptureMetadata
 */
export const CaptureMetadata = new CaptureMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CaptureInterval$Type extends MessageType<CaptureInterval> {
    constructor() {
        super("viam.app.data.v1.CaptureInterval", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CaptureInterval
 */
export const CaptureInterval = new CaptureInterval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataByFilterRequest$Type extends MessageType<TabularDataByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.TabularDataByFilterRequest", [
            { no: 1, name: "data_request", kind: "message", T: () => DataRequest },
            { no: 2, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_internal_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataByFilterRequest
 */
export const TabularDataByFilterRequest = new TabularDataByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataByFilterResponse$Type extends MessageType<TabularDataByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.TabularDataByFilterResponse", [
            { no: 1, name: "metadata", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CaptureMetadata },
            { no: 2, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TabularData },
            { no: 3, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 4, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "total_size_bytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataByFilterResponse
 */
export const TabularDataByFilterResponse = new TabularDataByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularData$Type extends MessageType<TabularData> {
    constructor() {
        super("viam.app.data.v1.TabularData", [
            { no: 1, name: "data", kind: "message", T: () => Struct },
            { no: 2, name: "metadata_index", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "time_requested", kind: "message", T: () => Timestamp },
            { no: 4, name: "time_received", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.TabularData
 */
export const TabularData = new TabularData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataBySQLRequest$Type extends MessageType<TabularDataBySQLRequest> {
    constructor() {
        super("viam.app.data.v1.TabularDataBySQLRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sql_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataBySQLRequest
 */
export const TabularDataBySQLRequest = new TabularDataBySQLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataBySQLResponse$Type extends MessageType<TabularDataBySQLResponse> {
    constructor() {
        super("viam.app.data.v1.TabularDataBySQLResponse", [
            { no: 2, name: "raw_data", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataBySQLResponse
 */
export const TabularDataBySQLResponse = new TabularDataBySQLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataSource$Type extends MessageType<TabularDataSource> {
    constructor() {
        super("viam.app.data.v1.TabularDataSource", [
            { no: 1, name: "type", kind: "enum", T: () => ["viam.app.data.v1.TabularDataSourceType", TabularDataSourceType, "TABULAR_DATA_SOURCE_TYPE_"] },
            { no: 2, name: "pipeline_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataSource
 */
export const TabularDataSource = new TabularDataSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataByMQLRequest$Type extends MessageType<TabularDataByMQLRequest> {
    constructor() {
        super("viam.app.data.v1.TabularDataByMQLRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "use_recent_data", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "data_source", kind: "message", T: () => TabularDataSource },
            { no: 7, name: "query_prefix_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataByMQLRequest
 */
export const TabularDataByMQLRequest = new TabularDataByMQLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataByMQLResponse$Type extends MessageType<TabularDataByMQLResponse> {
    constructor() {
        super("viam.app.data.v1.TabularDataByMQLResponse", [
            { no: 2, name: "raw_data", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.TabularDataByMQLResponse
 */
export const TabularDataByMQLResponse = new TabularDataByMQLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportTabularDataRequest$Type extends MessageType<ExportTabularDataRequest> {
    constructor() {
        super("viam.app.data.v1.ExportTabularDataRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "interval", kind: "message", T: () => CaptureInterval },
            { no: 6, name: "additional_parameters", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ExportTabularDataRequest
 */
export const ExportTabularDataRequest = new ExportTabularDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportTabularDataResponse$Type extends MessageType<ExportTabularDataResponse> {
    constructor() {
        super("viam.app.data.v1.ExportTabularDataResponse", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "time_captured", kind: "message", T: () => Timestamp },
            { no: 6, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "robot_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "method_parameters", kind: "message", T: () => Struct },
            { no: 12, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "payload", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ExportTabularDataResponse
 */
export const ExportTabularDataResponse = new ExportTabularDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestTabularDataRequest$Type extends MessageType<GetLatestTabularDataRequest> {
    constructor() {
        super("viam.app.data.v1.GetLatestTabularDataRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "additional_parameters", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetLatestTabularDataRequest
 */
export const GetLatestTabularDataRequest = new GetLatestTabularDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestTabularDataResponse$Type extends MessageType<GetLatestTabularDataResponse> {
    constructor() {
        super("viam.app.data.v1.GetLatestTabularDataResponse", [
            { no: 1, name: "time_captured", kind: "message", T: () => Timestamp },
            { no: 2, name: "time_synced", kind: "message", T: () => Timestamp },
            { no: 3, name: "payload", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetLatestTabularDataResponse
 */
export const GetLatestTabularDataResponse = new GetLatestTabularDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryData$Type extends MessageType<BinaryData> {
    constructor() {
        super("viam.app.data.v1.BinaryData", [
            { no: 1, name: "binary", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "metadata", kind: "message", T: () => BinaryMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryData
 */
export const BinaryData = new BinaryData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByFilterRequest$Type extends MessageType<BinaryDataByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.BinaryDataByFilterRequest", [
            { no: 1, name: "data_request", kind: "message", T: () => DataRequest },
            { no: 2, name: "include_binary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "include_internal_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryDataByFilterRequest
 */
export const BinaryDataByFilterRequest = new BinaryDataByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByFilterResponse$Type extends MessageType<BinaryDataByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.BinaryDataByFilterResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryData },
            { no: 2, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_size_bytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryDataByFilterResponse
 */
export const BinaryDataByFilterResponse = new BinaryDataByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryID$Type extends MessageType<BinaryID> {
    constructor() {
        super("viam.app.data.v1.BinaryID", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryID
 */
export const BinaryID = new BinaryID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByIDsRequest$Type extends MessageType<BinaryDataByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.BinaryDataByIDsRequest", [
            { no: 2, name: "include_binary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 4, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryDataByIDsRequest
 */
export const BinaryDataByIDsRequest = new BinaryDataByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataByIDsResponse$Type extends MessageType<BinaryDataByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.BinaryDataByIDsResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryData },
            { no: 2, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryDataByIDsResponse
 */
export const BinaryDataByIDsResponse = new BinaryDataByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundingBox$Type extends MessageType<BoundingBox> {
    constructor() {
        super("viam.app.data.v1.BoundingBox", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "x_min_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "y_min_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "x_max_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "y_max_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "confidence", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BoundingBox
 */
export const BoundingBox = new BoundingBox$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Classification$Type extends MessageType<Classification> {
    constructor() {
        super("viam.app.data.v1.Classification", [
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "confidence", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Classification
 */
export const Classification = new Classification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Annotations$Type extends MessageType<Annotations> {
    constructor() {
        super("viam.app.data.v1.Annotations", [
            { no: 1, name: "bboxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BoundingBox },
            { no: 2, name: "classifications", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Classification }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Annotations
 */
export const Annotations = new Annotations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryMetadata$Type extends MessageType<BinaryMetadata> {
    constructor() {
        super("viam.app.data.v1.BinaryMetadata", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "capture_metadata", kind: "message", T: () => CaptureMetadata },
            { no: 3, name: "time_requested", kind: "message", T: () => Timestamp },
            { no: 4, name: "time_received", kind: "message", T: () => Timestamp },
            { no: 5, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "file_ext", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "annotations", kind: "message", T: () => Annotations },
            { no: 9, name: "dataset_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "file_size_bytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.BinaryMetadata
 */
export const BinaryMetadata = new BinaryMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTabularFilter$Type extends MessageType<DeleteTabularFilter> {
    constructor() {
        super("viam.app.data.v1.DeleteTabularFilter", [
            { no: 1, name: "location_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "component_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tags_filter", kind: "message", T: () => TagsFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteTabularFilter
 */
export const DeleteTabularFilter = new DeleteTabularFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTabularDataRequest$Type extends MessageType<DeleteTabularDataRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteTabularDataRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delete_older_than_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "filter", kind: "message", T: () => DeleteTabularFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteTabularDataRequest
 */
export const DeleteTabularDataRequest = new DeleteTabularDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTabularDataResponse$Type extends MessageType<DeleteTabularDataResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteTabularDataResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteTabularDataResponse
 */
export const DeleteTabularDataResponse = new DeleteTabularDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByFilterRequest$Type extends MessageType<DeleteBinaryDataByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteBinaryDataByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "include_internal_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteBinaryDataByFilterRequest
 */
export const DeleteBinaryDataByFilterRequest = new DeleteBinaryDataByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByFilterResponse$Type extends MessageType<DeleteBinaryDataByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteBinaryDataByFilterResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteBinaryDataByFilterResponse
 */
export const DeleteBinaryDataByFilterResponse = new DeleteBinaryDataByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByIDsRequest$Type extends MessageType<DeleteBinaryDataByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteBinaryDataByIDsRequest", [
            { no: 2, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 3, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteBinaryDataByIDsRequest
 */
export const DeleteBinaryDataByIDsRequest = new DeleteBinaryDataByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByIDsResponse$Type extends MessageType<DeleteBinaryDataByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteBinaryDataByIDsResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteBinaryDataByIDsResponse
 */
export const DeleteBinaryDataByIDsResponse = new DeleteBinaryDataByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsToBinaryDataByIDsRequest$Type extends MessageType<AddTagsToBinaryDataByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.AddTagsToBinaryDataByIDsRequest", [
            { no: 3, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 4, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddTagsToBinaryDataByIDsRequest
 */
export const AddTagsToBinaryDataByIDsRequest = new AddTagsToBinaryDataByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsToBinaryDataByIDsResponse$Type extends MessageType<AddTagsToBinaryDataByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.AddTagsToBinaryDataByIDsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddTagsToBinaryDataByIDsResponse
 */
export const AddTagsToBinaryDataByIDsResponse = new AddTagsToBinaryDataByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsToBinaryDataByFilterRequest$Type extends MessageType<AddTagsToBinaryDataByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.AddTagsToBinaryDataByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.AddTagsToBinaryDataByFilterRequest
 */
export const AddTagsToBinaryDataByFilterRequest = new AddTagsToBinaryDataByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddTagsToBinaryDataByFilterResponse$Type extends MessageType<AddTagsToBinaryDataByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.AddTagsToBinaryDataByFilterResponse", []);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.AddTagsToBinaryDataByFilterResponse
 */
export const AddTagsToBinaryDataByFilterResponse = new AddTagsToBinaryDataByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveTagsFromBinaryDataByIDsRequest$Type extends MessageType<RemoveTagsFromBinaryDataByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest", [
            { no: 3, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 4, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByIDsRequest
 */
export const RemoveTagsFromBinaryDataByIDsRequest = new RemoveTagsFromBinaryDataByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveTagsFromBinaryDataByIDsResponse$Type extends MessageType<RemoveTagsFromBinaryDataByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByIDsResponse
 */
export const RemoveTagsFromBinaryDataByIDsResponse = new RemoveTagsFromBinaryDataByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveTagsFromBinaryDataByFilterRequest$Type extends MessageType<RemoveTagsFromBinaryDataByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByFilterRequest
 */
export const RemoveTagsFromBinaryDataByFilterRequest = new RemoveTagsFromBinaryDataByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveTagsFromBinaryDataByFilterResponse$Type extends MessageType<RemoveTagsFromBinaryDataByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveTagsFromBinaryDataByFilterResponse
 */
export const RemoveTagsFromBinaryDataByFilterResponse = new RemoveTagsFromBinaryDataByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TagsByFilterRequest$Type extends MessageType<TagsByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.TagsByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.TagsByFilterRequest
 */
export const TagsByFilterRequest = new TagsByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TagsByFilterResponse$Type extends MessageType<TagsByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.TagsByFilterResponse", [
            { no: 1, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.TagsByFilterResponse
 */
export const TagsByFilterResponse = new TagsByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBoundingBoxToImageByIDRequest$Type extends MessageType<AddBoundingBoxToImageByIDRequest> {
    constructor() {
        super("viam.app.data.v1.AddBoundingBoxToImageByIDRequest", [
            { no: 7, name: "binary_id", kind: "message", T: () => BinaryID },
            { no: 8, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "x_min_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "y_min_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "x_max_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "y_max_normalized", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "confidence", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddBoundingBoxToImageByIDRequest
 */
export const AddBoundingBoxToImageByIDRequest = new AddBoundingBoxToImageByIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBoundingBoxToImageByIDResponse$Type extends MessageType<AddBoundingBoxToImageByIDResponse> {
    constructor() {
        super("viam.app.data.v1.AddBoundingBoxToImageByIDResponse", [
            { no: 1, name: "bbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddBoundingBoxToImageByIDResponse
 */
export const AddBoundingBoxToImageByIDResponse = new AddBoundingBoxToImageByIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveBoundingBoxFromImageByIDRequest$Type extends MessageType<RemoveBoundingBoxFromImageByIDRequest> {
    constructor() {
        super("viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest", [
            { no: 3, name: "binary_id", kind: "message", T: () => BinaryID },
            { no: 4, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveBoundingBoxFromImageByIDRequest
 */
export const RemoveBoundingBoxFromImageByIDRequest = new RemoveBoundingBoxFromImageByIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveBoundingBoxFromImageByIDResponse$Type extends MessageType<RemoveBoundingBoxFromImageByIDResponse> {
    constructor() {
        super("viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveBoundingBoxFromImageByIDResponse
 */
export const RemoveBoundingBoxFromImageByIDResponse = new RemoveBoundingBoxFromImageByIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBoundingBoxRequest$Type extends MessageType<UpdateBoundingBoxRequest> {
    constructor() {
        super("viam.app.data.v1.UpdateBoundingBoxRequest", [
            { no: 1, name: "binary_id", kind: "message", T: () => BinaryID },
            { no: 8, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "label", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "x_min_normalized", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "y_min_normalized", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "x_max_normalized", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "y_max_normalized", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "confidence", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateBoundingBoxRequest
 */
export const UpdateBoundingBoxRequest = new UpdateBoundingBoxRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBoundingBoxResponse$Type extends MessageType<UpdateBoundingBoxResponse> {
    constructor() {
        super("viam.app.data.v1.UpdateBoundingBoxResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateBoundingBoxResponse
 */
export const UpdateBoundingBoxResponse = new UpdateBoundingBoxResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundingBoxLabelsByFilterRequest$Type extends MessageType<BoundingBoxLabelsByFilterRequest> {
    constructor() {
        super("viam.app.data.v1.BoundingBoxLabelsByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.BoundingBoxLabelsByFilterRequest
 */
export const BoundingBoxLabelsByFilterRequest = new BoundingBoxLabelsByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundingBoxLabelsByFilterResponse$Type extends MessageType<BoundingBoxLabelsByFilterResponse> {
    constructor() {
        super("viam.app.data.v1.BoundingBoxLabelsByFilterResponse", [
            { no: 1, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.data.v1.BoundingBoxLabelsByFilterResponse
 */
export const BoundingBoxLabelsByFilterResponse = new BoundingBoxLabelsByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigureDatabaseUserRequest$Type extends MessageType<ConfigureDatabaseUserRequest> {
    constructor() {
        super("viam.app.data.v1.ConfigureDatabaseUserRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ConfigureDatabaseUserRequest
 */
export const ConfigureDatabaseUserRequest = new ConfigureDatabaseUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigureDatabaseUserResponse$Type extends MessageType<ConfigureDatabaseUserResponse> {
    constructor() {
        super("viam.app.data.v1.ConfigureDatabaseUserResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ConfigureDatabaseUserResponse
 */
export const ConfigureDatabaseUserResponse = new ConfigureDatabaseUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDatabaseConnectionRequest$Type extends MessageType<GetDatabaseConnectionRequest> {
    constructor() {
        super("viam.app.data.v1.GetDatabaseConnectionRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetDatabaseConnectionRequest
 */
export const GetDatabaseConnectionRequest = new GetDatabaseConnectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDatabaseConnectionResponse$Type extends MessageType<GetDatabaseConnectionResponse> {
    constructor() {
        super("viam.app.data.v1.GetDatabaseConnectionResponse", [
            { no: 1, name: "hostname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mongodb_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "has_database_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetDatabaseConnectionResponse
 */
export const GetDatabaseConnectionResponse = new GetDatabaseConnectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBinaryDataToDatasetByIDsRequest$Type extends MessageType<AddBinaryDataToDatasetByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest", [
            { no: 1, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 3, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddBinaryDataToDatasetByIDsRequest
 */
export const AddBinaryDataToDatasetByIDsRequest = new AddBinaryDataToDatasetByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBinaryDataToDatasetByIDsResponse$Type extends MessageType<AddBinaryDataToDatasetByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddBinaryDataToDatasetByIDsResponse
 */
export const AddBinaryDataToDatasetByIDsResponse = new AddBinaryDataToDatasetByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveBinaryDataFromDatasetByIDsRequest$Type extends MessageType<RemoveBinaryDataFromDatasetByIDsRequest> {
    constructor() {
        super("viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest", [
            { no: 1, name: "binary_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryID },
            { no: 3, name: "binary_data_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsRequest
 */
export const RemoveBinaryDataFromDatasetByIDsRequest = new RemoveBinaryDataFromDatasetByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveBinaryDataFromDatasetByIDsResponse$Type extends MessageType<RemoveBinaryDataFromDatasetByIDsResponse> {
    constructor() {
        super("viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveBinaryDataFromDatasetByIDsResponse
 */
export const RemoveBinaryDataFromDatasetByIDsResponse = new RemoveBinaryDataFromDatasetByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSequencesToDatasetRequest$Type extends MessageType<AddSequencesToDatasetRequest> {
    constructor() {
        super("viam.app.data.v1.AddSequencesToDatasetRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sequence_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddSequencesToDatasetRequest
 */
export const AddSequencesToDatasetRequest = new AddSequencesToDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSequencesToDatasetResponse$Type extends MessageType<AddSequencesToDatasetResponse> {
    constructor() {
        super("viam.app.data.v1.AddSequencesToDatasetResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.AddSequencesToDatasetResponse
 */
export const AddSequencesToDatasetResponse = new AddSequencesToDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSequencesFromDatasetRequest$Type extends MessageType<RemoveSequencesFromDatasetRequest> {
    constructor() {
        super("viam.app.data.v1.RemoveSequencesFromDatasetRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sequence_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveSequencesFromDatasetRequest
 */
export const RemoveSequencesFromDatasetRequest = new RemoveSequencesFromDatasetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSequencesFromDatasetResponse$Type extends MessageType<RemoveSequencesFromDatasetResponse> {
    constructor() {
        super("viam.app.data.v1.RemoveSequencesFromDatasetResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.RemoveSequencesFromDatasetResponse
 */
export const RemoveSequencesFromDatasetResponse = new RemoveSequencesFromDatasetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIndexRequest$Type extends MessageType<CreateIndexRequest> {
    constructor() {
        super("viam.app.data.v1.CreateIndexRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection, "INDEXABLE_COLLECTION_"] },
            { no: 3, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "index_spec", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateIndexRequest
 */
export const CreateIndexRequest = new CreateIndexRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIndexResponse$Type extends MessageType<CreateIndexResponse> {
    constructor() {
        super("viam.app.data.v1.CreateIndexResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateIndexResponse
 */
export const CreateIndexResponse = new CreateIndexResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteIndexRequest$Type extends MessageType<DeleteIndexRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteIndexRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection, "INDEXABLE_COLLECTION_"] },
            { no: 3, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "index_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteIndexRequest
 */
export const DeleteIndexRequest = new DeleteIndexRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteIndexResponse$Type extends MessageType<DeleteIndexResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteIndexResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteIndexResponse
 */
export const DeleteIndexResponse = new DeleteIndexResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIndexesRequest$Type extends MessageType<ListIndexesRequest> {
    constructor() {
        super("viam.app.data.v1.ListIndexesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection, "INDEXABLE_COLLECTION_"] },
            { no: 3, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListIndexesRequest
 */
export const ListIndexesRequest = new ListIndexesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIndexesResponse$Type extends MessageType<ListIndexesResponse> {
    constructor() {
        super("viam.app.data.v1.ListIndexesResponse", [
            { no: 1, name: "indexes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Index }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListIndexesResponse
 */
export const ListIndexesResponse = new ListIndexesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Index$Type extends MessageType<Index> {
    constructor() {
        super("viam.app.data.v1.Index", [
            { no: 1, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection, "INDEXABLE_COLLECTION_"] },
            { no: 2, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "index_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "index_spec", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "created_by", kind: "enum", T: () => ["viam.app.data.v1.IndexCreator", IndexCreator, "INDEX_CREATOR_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Index
 */
export const Index = new Index$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSavedQueryRequest$Type extends MessageType<CreateSavedQueryRequest> {
    constructor() {
        super("viam.app.data.v1.CreateSavedQueryRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateSavedQueryRequest
 */
export const CreateSavedQueryRequest = new CreateSavedQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSavedQueryResponse$Type extends MessageType<CreateSavedQueryResponse> {
    constructor() {
        super("viam.app.data.v1.CreateSavedQueryResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateSavedQueryResponse
 */
export const CreateSavedQueryResponse = new CreateSavedQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Query$Type extends MessageType<Query> {
    constructor() {
        super("viam.app.data.v1.Query", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Query
 */
export const Query = new Query$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSavedQueryRequest$Type extends MessageType<DeleteSavedQueryRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteSavedQueryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteSavedQueryRequest
 */
export const DeleteSavedQueryRequest = new DeleteSavedQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSavedQueryResponse$Type extends MessageType<DeleteSavedQueryResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteSavedQueryResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteSavedQueryResponse
 */
export const DeleteSavedQueryResponse = new DeleteSavedQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSavedQueryRequest$Type extends MessageType<GetSavedQueryRequest> {
    constructor() {
        super("viam.app.data.v1.GetSavedQueryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSavedQueryRequest
 */
export const GetSavedQueryRequest = new GetSavedQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSavedQueryResponse$Type extends MessageType<GetSavedQueryResponse> {
    constructor() {
        super("viam.app.data.v1.GetSavedQueryResponse", [
            { no: 1, name: "saved_query", kind: "message", T: () => Query }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSavedQueryResponse
 */
export const GetSavedQueryResponse = new GetSavedQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSavedQueryRequest$Type extends MessageType<UpdateSavedQueryRequest> {
    constructor() {
        super("viam.app.data.v1.UpdateSavedQueryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateSavedQueryRequest
 */
export const UpdateSavedQueryRequest = new UpdateSavedQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSavedQueryResponse$Type extends MessageType<UpdateSavedQueryResponse> {
    constructor() {
        super("viam.app.data.v1.UpdateSavedQueryResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateSavedQueryResponse
 */
export const UpdateSavedQueryResponse = new UpdateSavedQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSavedQueriesRequest$Type extends MessageType<ListSavedQueriesRequest> {
    constructor() {
        super("viam.app.data.v1.ListSavedQueriesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListSavedQueriesRequest
 */
export const ListSavedQueriesRequest = new ListSavedQueriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSavedQueriesResponse$Type extends MessageType<ListSavedQueriesResponse> {
    constructor() {
        super("viam.app.data.v1.ListSavedQueriesResponse", [
            { no: 1, name: "queries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Query }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListSavedQueriesResponse
 */
export const ListSavedQueriesResponse = new ListSavedQueriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBinaryDataSignedURLRequest$Type extends MessageType<CreateBinaryDataSignedURLRequest> {
    constructor() {
        super("viam.app.data.v1.CreateBinaryDataSignedURLRequest", [
            { no: 1, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expiration_minutes", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateBinaryDataSignedURLRequest
 */
export const CreateBinaryDataSignedURLRequest = new CreateBinaryDataSignedURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBinaryDataSignedURLResponse$Type extends MessageType<CreateBinaryDataSignedURLResponse> {
    constructor() {
        super("viam.app.data.v1.CreateBinaryDataSignedURLResponse", [
            { no: 1, name: "signed_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateBinaryDataSignedURLResponse
 */
export const CreateBinaryDataSignedURLResponse = new CreateBinaryDataSignedURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SequenceResourceFilter$Type extends MessageType<SequenceResourceFilter> {
    constructor() {
        super("viam.app.data.v1.SequenceResourceFilter", [
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.SequenceResourceFilter
 */
export const SequenceResourceFilter = new SequenceResourceFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sequence$Type extends MessageType<Sequence> {
    constructor() {
        super("viam.app.data.v1.Sequence", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sequence_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 8, name: "resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SequenceResourceFilter },
            { no: 10, name: "dataset_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.Sequence
 */
export const Sequence = new Sequence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSequenceRequest$Type extends MessageType<CreateSequenceRequest> {
    constructor() {
        super("viam.app.data.v1.CreateSequenceRequest", [
            { no: 6, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SequenceResourceFilter },
            { no: 3, name: "sequence_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateSequenceRequest
 */
export const CreateSequenceRequest = new CreateSequenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSequenceResponse$Type extends MessageType<CreateSequenceResponse> {
    constructor() {
        super("viam.app.data.v1.CreateSequenceResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.CreateSequenceResponse
 */
export const CreateSequenceResponse = new CreateSequenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceRequest$Type extends MessageType<GetSequenceRequest> {
    constructor() {
        super("viam.app.data.v1.GetSequenceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSequenceRequest
 */
export const GetSequenceRequest = new GetSequenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceResponse$Type extends MessageType<GetSequenceResponse> {
    constructor() {
        super("viam.app.data.v1.GetSequenceResponse", [
            { no: 1, name: "sequence", kind: "message", T: () => Sequence }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSequenceResponse
 */
export const GetSequenceResponse = new GetSequenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSequenceRequest$Type extends MessageType<UpdateSequenceRequest> {
    constructor() {
        super("viam.app.data.v1.UpdateSequenceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SequenceResourceFilter },
            { no: 3, name: "sequence_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "field_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateSequenceRequest
 */
export const UpdateSequenceRequest = new UpdateSequenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSequenceResponse$Type extends MessageType<UpdateSequenceResponse> {
    constructor() {
        super("viam.app.data.v1.UpdateSequenceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.UpdateSequenceResponse
 */
export const UpdateSequenceResponse = new UpdateSequenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSequenceRequest$Type extends MessageType<DeleteSequenceRequest> {
    constructor() {
        super("viam.app.data.v1.DeleteSequenceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteSequenceRequest
 */
export const DeleteSequenceRequest = new DeleteSequenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSequenceResponse$Type extends MessageType<DeleteSequenceResponse> {
    constructor() {
        super("viam.app.data.v1.DeleteSequenceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.DeleteSequenceResponse
 */
export const DeleteSequenceResponse = new DeleteSequenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSequencesRequest$Type extends MessageType<ListSequencesRequest> {
    constructor() {
        super("viam.app.data.v1.ListSequencesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListSequencesRequest
 */
export const ListSequencesRequest = new ListSequencesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSequencesResponse$Type extends MessageType<ListSequencesResponse> {
    constructor() {
        super("viam.app.data.v1.ListSequencesResponse", [
            { no: 1, name: "sequences", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sequence },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.ListSequencesResponse
 */
export const ListSequencesResponse = new ListSequencesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SequencesByDatasetIDRequest$Type extends MessageType<SequencesByDatasetIDRequest> {
    constructor() {
        super("viam.app.data.v1.SequencesByDatasetIDRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.SequencesByDatasetIDRequest
 */
export const SequencesByDatasetIDRequest = new SequencesByDatasetIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SequencesByDatasetIDResponse$Type extends MessageType<SequencesByDatasetIDResponse> {
    constructor() {
        super("viam.app.data.v1.SequencesByDatasetIDResponse", [
            { no: 1, name: "sequences", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sequence },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.SequencesByDatasetIDResponse
 */
export const SequencesByDatasetIDResponse = new SequencesByDatasetIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceBinaryDataRequest$Type extends MessageType<GetSequenceBinaryDataRequest> {
    constructor() {
        super("viam.app.data.v1.GetSequenceBinaryDataRequest", [
            { no: 1, name: "sequence_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSequenceBinaryDataRequest
 */
export const GetSequenceBinaryDataRequest = new GetSequenceBinaryDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceBinaryDataResponse$Type extends MessageType<GetSequenceBinaryDataResponse> {
    constructor() {
        super("viam.app.data.v1.GetSequenceBinaryDataResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryData },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.data.v1.GetSequenceBinaryDataResponse
 */
export const GetSequenceBinaryDataResponse = new GetSequenceBinaryDataResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.data.v1.DataService
 */
export const DataService = new ServiceType("viam.app.data.v1.DataService", [
    { name: "TabularDataByFilter", options: {}, I: TabularDataByFilterRequest, O: TabularDataByFilterResponse },
    { name: "TabularDataBySQL", options: {}, I: TabularDataBySQLRequest, O: TabularDataBySQLResponse },
    { name: "TabularDataByMQL", options: {}, I: TabularDataByMQLRequest, O: TabularDataByMQLResponse },
    { name: "ExportTabularData", serverStreaming: true, options: {}, I: ExportTabularDataRequest, O: ExportTabularDataResponse },
    { name: "GetLatestTabularData", options: {}, I: GetLatestTabularDataRequest, O: GetLatestTabularDataResponse },
    { name: "BinaryDataByFilter", options: {}, I: BinaryDataByFilterRequest, O: BinaryDataByFilterResponse },
    { name: "BinaryDataByIDs", options: {}, I: BinaryDataByIDsRequest, O: BinaryDataByIDsResponse },
    { name: "DeleteTabularData", options: {}, I: DeleteTabularDataRequest, O: DeleteTabularDataResponse },
    { name: "DeleteBinaryDataByFilter", options: {}, I: DeleteBinaryDataByFilterRequest, O: DeleteBinaryDataByFilterResponse },
    { name: "DeleteBinaryDataByIDs", options: {}, I: DeleteBinaryDataByIDsRequest, O: DeleteBinaryDataByIDsResponse },
    { name: "AddTagsToBinaryDataByIDs", options: {}, I: AddTagsToBinaryDataByIDsRequest, O: AddTagsToBinaryDataByIDsResponse },
    { name: "AddTagsToBinaryDataByFilter", options: {}, I: AddTagsToBinaryDataByFilterRequest, O: AddTagsToBinaryDataByFilterResponse },
    { name: "RemoveTagsFromBinaryDataByIDs", options: {}, I: RemoveTagsFromBinaryDataByIDsRequest, O: RemoveTagsFromBinaryDataByIDsResponse },
    { name: "RemoveTagsFromBinaryDataByFilter", options: {}, I: RemoveTagsFromBinaryDataByFilterRequest, O: RemoveTagsFromBinaryDataByFilterResponse },
    { name: "TagsByFilter", options: {}, I: TagsByFilterRequest, O: TagsByFilterResponse },
    { name: "AddBoundingBoxToImageByID", options: {}, I: AddBoundingBoxToImageByIDRequest, O: AddBoundingBoxToImageByIDResponse },
    { name: "RemoveBoundingBoxFromImageByID", options: {}, I: RemoveBoundingBoxFromImageByIDRequest, O: RemoveBoundingBoxFromImageByIDResponse },
    { name: "BoundingBoxLabelsByFilter", options: {}, I: BoundingBoxLabelsByFilterRequest, O: BoundingBoxLabelsByFilterResponse },
    { name: "UpdateBoundingBox", options: {}, I: UpdateBoundingBoxRequest, O: UpdateBoundingBoxResponse },
    { name: "GetDatabaseConnection", options: {}, I: GetDatabaseConnectionRequest, O: GetDatabaseConnectionResponse },
    { name: "ConfigureDatabaseUser", options: {}, I: ConfigureDatabaseUserRequest, O: ConfigureDatabaseUserResponse },
    { name: "AddBinaryDataToDatasetByIDs", options: {}, I: AddBinaryDataToDatasetByIDsRequest, O: AddBinaryDataToDatasetByIDsResponse },
    { name: "RemoveBinaryDataFromDatasetByIDs", options: {}, I: RemoveBinaryDataFromDatasetByIDsRequest, O: RemoveBinaryDataFromDatasetByIDsResponse },
    { name: "AddSequencesToDataset", options: {}, I: AddSequencesToDatasetRequest, O: AddSequencesToDatasetResponse },
    { name: "RemoveSequencesFromDataset", options: {}, I: RemoveSequencesFromDatasetRequest, O: RemoveSequencesFromDatasetResponse },
    { name: "CreateIndex", options: {}, I: CreateIndexRequest, O: CreateIndexResponse },
    { name: "ListIndexes", options: {}, I: ListIndexesRequest, O: ListIndexesResponse },
    { name: "DeleteIndex", options: {}, I: DeleteIndexRequest, O: DeleteIndexResponse },
    { name: "CreateSavedQuery", options: {}, I: CreateSavedQueryRequest, O: CreateSavedQueryResponse },
    { name: "UpdateSavedQuery", options: {}, I: UpdateSavedQueryRequest, O: UpdateSavedQueryResponse },
    { name: "GetSavedQuery", options: {}, I: GetSavedQueryRequest, O: GetSavedQueryResponse },
    { name: "DeleteSavedQuery", options: {}, I: DeleteSavedQueryRequest, O: DeleteSavedQueryResponse },
    { name: "ListSavedQueries", options: {}, I: ListSavedQueriesRequest, O: ListSavedQueriesResponse },
    { name: "CreateBinaryDataSignedURL", options: {}, I: CreateBinaryDataSignedURLRequest, O: CreateBinaryDataSignedURLResponse },
    { name: "CreateSequence", options: {}, I: CreateSequenceRequest, O: CreateSequenceResponse },
    { name: "GetSequence", options: {}, I: GetSequenceRequest, O: GetSequenceResponse },
    { name: "UpdateSequence", options: {}, I: UpdateSequenceRequest, O: UpdateSequenceResponse },
    { name: "DeleteSequence", options: {}, I: DeleteSequenceRequest, O: DeleteSequenceResponse },
    { name: "ListSequences", options: {}, I: ListSequencesRequest, O: ListSequencesResponse },
    { name: "SequencesByDatasetID", options: {}, I: SequencesByDatasetIDRequest, O: SequencesByDatasetIDResponse },
    { name: "GetSequenceBinaryData", options: {}, I: GetSequenceBinaryDataRequest, O: GetSequenceBinaryDataResponse }
]);
